/**
 * SuggestionDescriptionComposer
 *
 * Composes an event description string from an AI suggestion's description and
 * action items, embedding actions as an ---tasks--- checklist section so they
 * render as event tasks when the event is created.
 */

export class SuggestionDescriptionComposer {
  /**
   * Build a combined description for a calendar event created from a suggestion.
   * Appends action items as unchecked checkboxes inside a ---tasks--- section.
   */
  static composeEventDescription(
    description: string | undefined,
    actions: string[] | undefined,
  ): string | undefined {
    const trimmedDescription = (description ?? '').trim();
    const cleanActions = (actions ?? [])
      .map((action) => action.trim())
      .filter((action) => action.length > 0);

    if (cleanActions.length === 0) {
      return trimmedDescription.length > 0 ? trimmedDescription : undefined;
    }

    const tasksBlock = [
      '---tasks---',
      ...cleanActions.map((action) => `- [ ] ${action}`),
      '---/tasks---',
    ].join('\n');

    if (trimmedDescription.length === 0) return tasksBlock;

    return `${trimmedDescription}\n\n${tasksBlock}`;
  }
}
